import React from 'react'
import { WithContext as ReactTags } from 'react-tag-input';
import './RequiredJobTitle.css'
import { JOB_PROFILES } from './JobProfiles';

const suggestions = JOB_PROFILES.map((jobProfile) => {
    return {
        id: jobProfile,
        text: jobProfile,
    };
});

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const RequiredJobTitle = ({ tags, setTags }) => {
    const handleDelete = (i) => {
        setTags(tags.filter((tag, index) => index !== i));
    };

    const handleAddition = (tag) => {
        setTags([...tags, tag]);
    };

    return (
        <ReactTags
            tags={tags}
            suggestions={suggestions}
            delimiters={delimiters}
            handleDelete={handleDelete}
            handleAddition={handleAddition}
            allowDragDrop={false}
            allowDeleteFromEmptyInput={false}
            placeholder="Press enter to add new required job title"
            editable
            autofocus={false}
            inputFieldPosition="top"
        />
    )
}

export default RequiredJobTitle